module.exports = __webpack_public_path__ + "img/clock.247040a8.svg";